module.exports = __webpack_public_path__ + "img/编组 2@2x (2).f71062bb.png";